import { render, staticRenderFns } from "./deletePeople.vue?vue&type=template&id=c114318a&scoped=true&"
import script from "./deletePeople.vue?vue&type=script&lang=js&"
export * from "./deletePeople.vue?vue&type=script&lang=js&"
import style0 from "./deletePeople.vue?vue&type=style&index=0&id=c114318a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c114318a",
  null
  
)

export default component.exports